import React from "react";
interface ModalBtnProps {
  // Legacy props (for backward compatibility)
  setopen?: (value: boolean) => void;
  submit?: string;
  cancel?: string;

  // New props pattern
  btnText1?: string;
  btnText2?: string;
  handleClose?: () => void;
  handleClick?: () => void | Promise<void>;
}

const ModelBtn: React.FC<ModalBtnProps> = ({
  setopen,
  submit = "submit",
  cancel = "cancel",
  btnText1,
  btnText2,
  handleClose,
  handleClick,
}) => {
  // Use new pattern if provided, otherwise fall back to legacy
  const closeHandler = handleClose || (() => setopen?.(false));
  const submitText = btnText1 || submit;
  const cancelText = btnText2 || cancel;

  const handleSubmit = (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (handleClick) {
      e?.preventDefault();
      handleClick();
    }
  };

  return (
    <div className="model_btn">
      <button className="cancel" onClick={closeHandler}>
        {cancelText}
      </button>
      <button
        className="submit"
        type={handleClick ? "button" : "submit"}
        onClick={handleClick ? handleSubmit : undefined}
      >
        {submitText}
      </button>
    </div>
  );
};

export default ModelBtn;
